import nodeClient from "./node-client";

export const getCustomerCategories = async (paylaod) => {
  const response = await nodeClient.post(
    `/service/private/v0/patientCategory/categoryList`,
    paylaod
  );
  return response?.data;
};

export const saveCustomerCategory = async (paylaod) => {
  const response = await nodeClient.post(
    `/service/private/v0/patientCategory/add`,
    paylaod
  );
  return response?.data;
};
